import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LikedUser, ShortFollowedUser } from '../../interfaces';
import { MemberAvatarComponent } from '../member-avatar/member-avatar.component';
import { FollowButtonComponent } from '../follow-button/follow-button.component';
import { ExcerptPipe } from '../../pipes/excerpt.pipe';

const FOLLOWED_USERS_SLICE_SIZE = 2;

@Component({
  selector: 'ol-follow-member',
  templateUrl: './follow-member.component.html',
  styleUrls: ['./follow-member.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MemberAvatarComponent, FollowButtonComponent, ExcerptPipe],
})
export class FollowMemberComponent {
  member = input.required<LikedUser>();
  showFollowBtn = input<boolean>(true);
  memberClickEvent = output<LikedUser>();

  followedUsers = computed(() => this.member().followed_by);
  followedUsersSlice = computed(() => this.followedUsers().slice(0, FOLLOWED_USERS_SLICE_SIZE));

  followerStacksStyles = (followedUser: ShortFollowedUser) => ({
    backgroundImage: `url(${followedUser?.avatar_url})`,
  });
}
